module.exports = __webpack_public_path__ + "img/icon-edit-blue.d5e1ab44.svg";